import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { saveClientNewEmployeePath } from "../../services/config";

import { config } from "../../services/configHeader";

const user = JSON.parse(localStorage.getItem("user_data")) || {};
// const userId = user?.user_id;
const accountType = user?.account_type;
const baseUrl = process.env.REACT_APP_BASE_URI;

const initialState = {
  empLoading: false,
  empSuccess: false,
  empMessage: null,
  empData: null,

  empGetLoading: false,
  empGetSuccess: false,
  empGetError: false,
  empGetMessage: null,
  empGetData: null,

  empGetLoadingOne: false,
  empGetSuccessOne: false,
  empGetMessageOne: null,
  empGetDataOne: null,

  empGetLoadingTwo: false,
  empGetSuccessTwo: false,
  empGetMessageTwo: null,
  empGetDataTwo: null,

  empGetLoadingThree: false,
  empGetSuccessThree: false,
  empGetMessageThree: null,
  empGetDataThree: null,

  empGetLoadingFour: false,
  empGetSuccessFour: false,
  empGetMessageFour: null,
  empGetDataFour: null,
};

export const getEmployeeData = createAsyncThunk(
  "getEmployeeData",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          let data = {
            response: {
              data: {
                message: error.message,
              },
            },
          };
          return error;
        }
      });
  }
);

export const getEmployeeDataOne = createAsyncThunk(
  "getEmployeeDataOne",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          let data = {
            response: {
              data: {
                message: error.message,
              },
            },
          };
          return error;
        }
      });
  }
);

export const getEmployeeDataTwo = createAsyncThunk(
  "getEmployeeDataTwo",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          let data = {
            response: {
              data: {
                message: error.message,
              },
            },
          };
          return error;
        }
      });
  }
);

export const getEmployeeDataThree = createAsyncThunk(
  "getEmployeeDataThree",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          let data = {
            response: {
              data: {
                message: error.message,
              },
            },
          };
          return error;
        }
      });
  }
);

export const getEmployeeDataFour = createAsyncThunk(
  "getEmployeeDataFour",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          let data = {
            response: {
              data: {
                message: error.message,
              },
            },
          };
          return error;
        }
      });
  }
);

export const createEmployee = createAsyncThunk(
  "createEmployee",
  async (data) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };
    return parseInt(accountType) === 2
      ? result
      : await axios
        .post(`${baseUrl}${saveClientNewEmployeePath}`, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
              data: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          } else {
            return error;
          }
        });
  }
);

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    initEmpState: (state) => {
      state.empGetLoading = false;
      state.empGetSuccess = false;
      state.empGetMessage = null;
      state.empGetData = null;

      state.empLoading = false;
      state.empSuccess = false;
      state.empError = false;
      state.empMessage = null;
      state.empData = null;
    },

    initRmLevel1State: (state) => {
      state.empGetLoadingOne = false;
      state.empGetSuccessOne = false;
      state.empGetMessageOne = null;
      state.empGetDataOne = null;
    },

    initRmLevel2State: (state) => {
      state.empGetLoadingTwo = false;
      state.empGetSuccessTwo = false;
      state.empGetMessageTwo = null;
      state.empGetDataTwo = null;
    },

    initRmLevel3State: (state) => {
      state.empGetLoadingThree = false;
      state.empGetSuccessThree = false;
      state.empGetMessageThree = null;
      state.empGetDataThree = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getEmployeeData.pending, (state) => {
      state.empGetLoading = true;
      state.empGetSuccess = false;
      state.empGetMessage = null;
      state.empGetData = null;
    });
    builder.addCase(getEmployeeData.fulfilled, (state, action) => {
      state.empGetLoading = false;
      state.empGetSuccess = true;
      state.empGetMessage =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.message
          : action.payload.data.msg;
      state.empGetData =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.data
          : null;
    });
    builder.addCase(getEmployeeData.rejected, (state, action) => {
      state.empGetLoading = false;
      state.empGetSuccess = false;
      state.empGetMessage =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.message
          : action.payload.data.msg;
      state.empGetData =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.data
          : null;
    });
    // ==================================================== getEmployeeDataTwo
    builder.addCase(getEmployeeDataOne.pending, (state) => {
      state.empGetLoadingOne = true;
      state.empGetSuccessOne = false;
      state.empGetMessageOne = null;
      state.empGetDataOne = null;
    });
    builder.addCase(getEmployeeDataOne.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200 || status == "200") {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.empGetLoadingOne = false;
          state.empGetSuccessOne = true;
          state.empGetErrorOne = false;
          state.empGetMessageOne = action.payload.data.message;
          state.empGetDataOne = action.payload.data.data;
        } else {
          state.empGetLoadingOne = false;
          state.empGetSuccessOne = false;
          state.empGetErrorOne = true;
          state.empGetMessageOne = action.payload.data.msg;
          state.empGetDataOne = null;
        }
      } else {
        console.log("action.payload action.payload", action.payload)
        state.empGetLoadingOne = false;
        state.empGetSuccessOne = false;
        state.empGetErrorOne = true;
        state.empGetMessageOne = action.payload.response.data.message;
        state.empGetDataOne = null;
      }
    });
    builder.addCase(getEmployeeDataOne.rejected, (state, action) => {
      state.empGetLoadingOne = false;
      state.empGetSuccessOne = false;
      state.empGetMessageOne =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.message
          : action.payload.data.msg;
      state.empGetDataOne =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.data
          : null;
    });

    // =====================================================
    builder.addCase(getEmployeeDataTwo.pending, (state) => {
      state.empGetLoadingTwo = true;
      state.empGetSuccessTwo = false;
      state.empGetMessageTwo = null;
      state.empGetDataTwo = null;
    });
    builder.addCase(getEmployeeDataTwo.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200 || status == "200") {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.empGetLoadingTwo = false;
          state.empGetSuccessTwo = true;
          state.empGetErrorTwo = false;
          state.empGetMessageTwo = action.payload.data.message;
          state.empGetDataTwo = action.payload.data.data;
        } else {
          state.empGetLoadingTwo = false;
          state.empGetSuccessTwo = false;
          state.empGetErrorTwo = true;
          state.empGetMessageTwo = action.payload.data.msg;
          state.empGetDataTwo = null;
        }
      } else {
        console.log("action.payload action.payload", action.payload)
        state.empGetLoadingTwo = false;
        state.empGetSuccessTwo = false;
        state.empGetErrorTwo = true;
        state.empGetMessageTwo = action.payload.response.data.message;
        state.empGetDataTwo = null;
      }
    });
    builder.addCase(getEmployeeDataTwo.rejected, (state, action) => {
      state.empGetLoadingTwo = false;
      state.empGetSuccessTwo = false;
      state.empGetMessageTwo =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.message
          : action.payload.data.msg;
      state.empGetDataTwo =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.data
          : null;
    });
    // =====================================================
    builder.addCase(getEmployeeDataThree.pending, (state) => {
      state.empGetLoadingThree = true;
      state.empGetSuccessThree = false;
      state.empGetMessageThree = null;
      state.empGetDataThree = null;
    });
    builder.addCase(getEmployeeDataThree.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200 || status == "200") {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.empGetLoadingThree = false;
          state.empGetSuccessThree = true;
          state.empGetErrorThree = false;
          state.empGetMessageThree = action.payload.data.message;
          state.empGetDataThree = action.payload.data.data;
        } else {
          state.empGetLoadingThree = false;
          state.empGetSuccessThree = false;
          state.empGetErrorThree = true;
          state.empGetMessageThree = action.payload.data.msg;
          state.empGetDataThree = null;
        }
      } else {
        console.log("action.payload action.payload", action.payload)
        state.empGetLoadingThree = false;
        state.empGetSuccessThree = false;
        state.empGetErrorThree = true;
        state.empGetMessageThree = action.payload.response.data.message;
        state.empGetDataThree = null;
      }
    });
    builder.addCase(getEmployeeDataThree.rejected, (state, action) => {
      state.empGetLoadingThree = false;
      state.empGetSuccessThree = false;
      state.empGetMessageThree =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.message
          : action.payload.data.msg;
      state.empGetDataThree =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.data
          : null;
    });
    // =====================================================
    builder.addCase(getEmployeeDataFour.pending, (state) => {
      state.empGetLoadingFour = true;
      state.empGetSuccessFour = false;
      state.empGetMessageFour = null;
      state.empGetDataFour = null;
    });
    builder.addCase(getEmployeeDataFour.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200 || status == "200") {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.empGetLoadingFour = false;
          state.empGetSuccessFour = true;
          state.empGetErrorFour = false;
          state.empGetMessageFour = action.payload.data.message;
          state.empGetDataFour = action.payload.data.data;
        } else {
          state.empGetLoadingFour = false;
          state.empGetSuccessFour = false;
          state.empGetErrorFour = true;
          state.empGetMessageFour = action.payload.data.msg;
          state.empGetDataFour = null;
        }
      } else {
        console.log("action.payload action.payload", action.payload)
        state.empGetLoadingFour = false;
        state.empGetSuccessFour = false;
        state.empGetErrorFour = true;
        state.empGetMessageFour = action.payload.response.data.message;
        state.empGetDataFour = null;
      }
    });
    builder.addCase(getEmployeeDataFour.rejected, (state, action) => {
      state.empGetLoadingFour = false;
      state.empGetSuccessFour = false;
      state.empGetMessageFour =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.message
          : action.payload.data.msg;
      state.empGetDataFour =
        action.payload.data.status == true ||
          action.payload.data.status == "true"
          ? action.payload.data.data
          : null;
    });




    // ====================================================
    builder.addCase(createEmployee.pending, (state) => {
      state.empLoading = true;
      state.empSuccess = false;
      state.empError = false;
      state.empMessage = null;
      state.empData = null;
    });

    builder.addCase(createEmployee.fulfilled, (state, action) => {

      const status = action.payload.status;
      if (status == 200 || status == "200") {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.empLoading = false;
          state.empSuccess = true;
          state.empError = false;
          state.empMessage = action.payload.data.message;
          state.empData = action.payload.data.data;
        } else {
          state.empLoading = false;
          state.empSuccess = false;
          state.empError = true;
          state.empMessage = action.payload.data.message
            ? action.payload.data.message
            : action.payload.data.msg;
          state.empData = null;
        }
      } else {
        state.empLoading = false;
        state.empSuccess = false;
        state.empError = true;
        state.empMessage = action.payload.response.data.message;
        state.empData = action.payload.response.data.data;
      }


      // if (action.payload.status == 200) {
      //   state.empLoading = false;
      //   state.empSuccess = accountType == 2 ? false : true;
      //   state.empError = accountType == 2 ? true : false;
      //   state.empMessage = action.payload.data.message;
      //   state.empData = null;
      // } else {
      //   state.empLoading = false;
      //   state.empSuccess = false;
      //   state.empError = true;
      //   state.empMessage = action.payload.response.data.message;
      //   state.empData = null;
      // }
    });

    builder.addCase(createEmployee.rejected, (state, action) => {
      state.empLoading = false;
      state.empSuccess = true;
      state.empError = false;
      state.empMessage = action.payload.data;
      state.empData = null;
    });
    // Get employee data
  },
});

export const { initEmpState, initRmLevel1State, initRmLevel2State, initRmLevel3State } = employeeSlice.actions;

export default employeeSlice.reducer;
